import React, { FC } from 'react';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { ButtonComponent } from '../ButtonComponent';
import { useFormik } from 'formik';
import {
	CUSTOM_KEY_FORM_FIELD, CUSTOM_KEY_FORM_FIELD_NAMES,
	getCustomKeyDetailsSchema,
	initialCustomKeyValues
} from '../../constants/custom-key/custom-key-form';
import { useTranslation } from 'react-i18next';
import { setCustomKey, useApiClientContext } from '../../store/api-client-context';
import { useParams } from 'react-router-dom';

interface Props {
	onSuccess: () => void;
	onError: () => void;
}

export const CreateCustomKeyModal: FC<Props> = (props) => {
	const { onSuccess, onError } = props;

	const { t } = useTranslation();
	const { partnerId } = useParams();
	const { apiClientContextState: { isCreatingCustomKey }, dispatch } = useApiClientContext();

	const formik = useFormik({
		initialValues: initialCustomKeyValues,
		validationSchema: getCustomKeyDetailsSchema,
		onSubmit: () => setCustomKey(dispatch, formik, onSuccess, onError, partnerId)
	});

	return (
		<form className="row px-8" onSubmit={formik.handleSubmit}>
			<FormInput
				formik={formik}
				fieldName={CUSTOM_KEY_FORM_FIELD.KEY_NAME}
				label={CUSTOM_KEY_FORM_FIELD_NAMES.KEY_NAME}
				placeholder={CUSTOM_KEY_FORM_FIELD_NAMES.KEY_NAME}
				inputType={InputType.Text}
				additionalClasses="col-md-6"
				key={CUSTOM_KEY_FORM_FIELD.KEY_NAME}
			/>
			<div className="col-1"/>
			<FormInput
				formik={formik}
				fieldName={CUSTOM_KEY_FORM_FIELD.NOTE}
				label={CUSTOM_KEY_FORM_FIELD_NAMES.NOTE}
				placeholder={CUSTOM_KEY_FORM_FIELD_NAMES.NOTE}
				inputType={InputType.Description}
				additionalClasses="col-md-12"
				key={CUSTOM_KEY_FORM_FIELD.NOTE}
			/>
			<ButtonComponent
				buttonName={t('PARTNERS.SAVE_BTN_NAME')}
				additionalClass="btn-sm d-block ms-auto w-100px mb-5 me-2"
				type="submit"
				isDisabled={isCreatingCustomKey || !formik.values[CUSTOM_KEY_FORM_FIELD.KEY_NAME]}
				loading={isCreatingCustomKey}
			/>
		</form>
	);
};
